import datetimemixin from '@/helpers/Mixins/DateTimeMixin'
import erpconfigmixin from '@/helpers/Mixins/ERPConfigMixin'
import filtermixin from '@/helpers/Mixins/FilterMixin'
import licencesmixin from '@/helpers/Mixins/LicencesMixin'
import QInputRuleMixin from '@/helpers/Mixins/QInputRuleMixin'
import routingmixin from '@/helpers/Mixins/RoutingHelperMixin'
import AccessMatrix from '@/router/access-matrix'
import router from '@/router/index'
import store from '@/store'
import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'
import App from './App.vue'
import './plugins/gmaps'
import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'
import { LocaleManager } from '@bryntum/schedulerpro'

//import "jquery-ui/themes/base/all.css"
//import "devextreme/dist/css/dx.light.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css"
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css"
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css"

export const loadedGoogleMapsAPI = function (key) {
  return new Promise((resolve) => {
    if (window['GoogleMapsInit'] === undefined) {
      window['GoogleMapsInit'] = resolve;
      let GMap = window.document.createElement('script');
      GMap.async = true;
      GMap.defer = true;
      GMap.setAttribute('src',
        `https://maps.googleapis.com/maps/api/js?key=${key}&callback=GoogleMapsInit&loading=async&libraries=maps,marker&v=beta`);

      window.document.body.appendChild(GMap);
    }
    else {
      resolve();
    }
  });
}

const lang = localStorage.getItem('lang') || 'en';
axios.defaults.headers['Accept-Language'] = lang;

// Ensure ISO-style week numbering (Mon-first) for DateHelper.format tokens (WW, Wp, WWp)
// Merge into current locale to keep existing strings like L{Week} available
const currentLocale = LocaleManager.locale || LocaleManager.locales.En;
LocaleManager.applyLocale({
  ...currentLocale,
  DateHelper: {
    ...(currentLocale?.DateHelper || {}),
    weekStartDay: 1,
  },
})

Array.prototype.take = function (count) {
  return this.slice(0, count);
}

Date.prototype.addDays = function (d) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + d);
  return date;
}
Date.prototype.addHours = function (h) {
  this.setHours(this.getHours() + h);
  return this;
}
Array.prototype.last = function () {
  return this[this.length - 1];
}
Vue.config.productionTip = false
Vue.mixin({

  mixins: [licencesmixin, erpconfigmixin, filtermixin, datetimemixin, routingmixin, QInputRuleMixin],

  methods: {
    async toClipboard(value) {
      try {
        await navigator.clipboard.writeText(value);
      } catch ($e) {
        alert('unable to copy text');
      }
    },
    SameValue(val1, val2) {
      const strA = JSON.stringify(val1);
      const strB = JSON.stringify(val2);
      var same = (strA === strB)

      return same
    },

    translateIfKey(key) {
      return key.includes('servicesystem.') ? this.$t(key) : key
    },

    parseCommaSafeDecimalField(field) {
      return parseFloat(field?.toString().replace(',', '.').replace(' ', '')) || 0;
    },

    addressDtoToString(dto) {
      if (dto) {
        return [dto.Street, dto.City, dto.Zip, dto.Country].join(" ");
      }
      else {
        return ''
      }

    },

    isValidId(id) {
      var result = /^[0-9]*$/.test(id);
      return result
    },

    isValidDate(date) {
      if (Object.prototype.toString.call(date) === "[object Date]") {
        return true;
      } else {
        return false;
      }
    },

    checkUserAuthorizationForNode(node) {
      var result = true;
      const authorize = node && node.meta ? node.meta.authorize : null;
      if (authorize && authorize.length && !authorize.includes(this.userInfo.UserTypeId)) {  //if: route is restricted by role and you dont have that role
        result = false;
      }
      return result;
    },

    // Round to nearest tens of a cent and display two decimal values after comma
    formatCurrencyTotal(currency) {
      var dvalue = Math.round(currency * 10) / 10;
      return `${dvalue.toFixed(2)}${this.moneySign}`;
    },
    formatMoney(number) {
      // Create our number formatter.
      var formatter = new Intl.NumberFormat(this.serverCulture, {
        style: "currency",
        currency: this.currencyCode,

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });

      return formatter.format(number); /* $2,500.00 */
    },
    // round to nearest cent and display two decimal values after comma
    formatCurrency(currency) {
      var dvalue = Math.round(currency * 100) / 100;
      return `${dvalue.toFixed(2)}${this.moneySign}`;
    },

    //method for markin every second element in a list with a odd = true attribute
    oddMarkList(list) {
      if (list) {
        for (let index = 0; index < list.length; index++) {
          if (index % 2) {
            list[index].odd = true;
          }
          else {
            list[index].odd = false;
          }
        }
        return list;
      }
      return false;
    },

    showSnackbar(snackbarproperties) {
      this.$store.dispatch("triggerevents/showGlobalSnackbar", snackbarproperties);
    },

    snackResponse(response, method, text, color, timeout, icon) {
      var code = response && response.status ? response.status : undefined;
      var errortext;
      var subtext;
      console.log(text)
      if (text) {
        errortext = text;
        subtext = response ? response.data : null;
      } else if (response && response.data) {
        errortext = response.data;
      } else if (method) {
        errortext = 'Exception in ' + method;
      } else {
        errortext = undefined;
      }
      this.showSnackbar({ code: code, text: errortext, subtext: subtext, color: color, timeout: timeout, icon: icon });
      if (response) {
        if (response.code > 399) {
          throw response && response.data;
        }
      }
    },

    routeIcon(item) {
      return item?.meta?.icon ?? 'mdi-help-box'
    },

    routeDisplayName(item) {

      return item?.meta?.display?.key ? this.$t(item?.meta?.display?.key) : item?.meta?.displayName ?? item.name ?? 'UNNAMED ROUTE'
    },

    routeCount(item) {
      return item?.meta?.count ?? 0
    },

    isHiddenJobStatus(job) {
      return job.JobStatusId > 70 ? true : false;
    },

    checkPermission(module, permission) {
      var accesslist;
      var permit = false;

      if (module && module in AccessMatrix) {
        accesslist = AccessMatrix[module]
        if (permission && permission in accesslist) {
          accesslist = accesslist[permission]
        }
        else if ('module' in accesslist) {
          accesslist = accesslist['module']
        }
        else {
          return permit;
        }
      }
      else {
        return permit;
      }

      if (accesslist && accesslist.includes(this.userInfo.UserTypeId)) {
        permit = true;
      }

      return permit;
    },

    avoidduplicatekey(key, add) {
      const orgVal = key;
      return add + orgVal;
    },

    inProgress(appointment, overridetime) {
      var now = overridetime ? overridetime : moment();
      var start = moment(appointment.StartTime);
      var end = moment(appointment.EndTime);
      if (now.isBefore(start)) {
        //if appointment will happen in the future
        return 1;
      } else if (now.isAfter(start) && now.isBefore(end)) {
        //if appointment is happening right now
        return 0;
      } else {
        //else has allready passed
        return -1;
      }
    },

    progressColor(appointment, overridetime) {
      var state = this.inProgress(appointment, overridetime);
      if (state === 1) {
        return "primary";
      } else if (state === 0) {
        return "tertiary";
      } else {
        return "disabled";
      }
    },

    statuscolor(statusid) {
      var status = this.$store.getters["LookUpStore/JobStatus"](statusid);
      return status.Color;
    },
    statusicon(statusid) {
      var status = this.$store.getters["LookUpStore/JobStatus"](statusid);
      return status.Icon;
    },

    fromNow(dt) {
      return moment(dt).fromNow();
    },

    isYou(userid) {
      return userid === this.userInfo.Id;
    },

    UTCSecureAppointment(appointment) {
      appointment.AppointmentDate = this.getDateFromString(appointment.AppointmentDate).toISOString();
      appointment.StartTime = this.getDateFromString(appointment.StartTime).toISOString();
      appointment.EndTime = this.getDateFromString(appointment.EndTime).toISOString();
    },

    log(arg1) {
      console.log(arg1);
    },

    addressIdIsDefaultForCustomer(id) {
      if ((typeof id === 'string' || id instanceof String) && id.startsWith('-')) {
        return true;
      }
      else {
        return false;
      }
    },
    addressIdIsFromErp(id) {
      if ((typeof id === 'string' || id instanceof String) && id.startsWith('_')) {
        return true;
      }
      else {
        return false;
      }
    },

    hasMalformedOrderId(job) {
      var isMalformed
      if (job.ParentId) {
        isMalformed = job.JobTypeId != 3 && (!job.OrderId || (!job.OrderId.includes('L') && !job.OrderId.includes('L')))

        return isMalformed
      }
      else {
        isMalformed = job.JobTypeId != 3 && !job.OrderId

        return isMalformed
      }
    }
  },
  computed: {
    serverCulture() {
      return this.$store.state.GlobalSettings.Culture;
    },

    currencyCode() {
      return this.$store.state.GlobalSettings.CurrencyFormat;
    },

    moneySign() {
      // Currencies where some runtimes return code instead of symbol; map code -> symbol
      const currencySymbolFallback = {
        HKD: 'HK$',
        MOP: 'MOP$',
        TWD: 'NT$',
        SGD: 'S$',
        JPY: '¥',
      };
      const formatter = new Intl.NumberFormat(this.serverCulture, {
        style: 'currency',
        currency: this.currencyCode,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      const parts = formatter.formatToParts(0);
      const currencyPart = parts.find(p => p.type === 'currency');
      let symbol = (currencyPart && currencyPart.value) ? currencyPart.value.trim() : this.currencyCode;
      // If runtime returned the code instead of symbol (e.g. "HKD"), use fallback
      if (currencySymbolFallback[this.currencyCode] && symbol === this.currencyCode) {
        symbol = currencySymbolFallback[this.currencyCode];
      }
      return symbol;
    },

    dragOptions() {
      return {
        delay: 200, // Delay in milliseconds
        delayOnTouchOnly: true, // Apply delay only on touch devices
      }
    },

    globalSearchterm() {
      return this.$store.state.globalSearchQuery;
    },

    //returns version object from store, populated by userinfo request
    Version() {
      return this.$store.getters["Version"];
    },

    //returns true if device is wider than 1904px
    isUltrawideBool() {
      return this.$vuetify.breakpoint.xlOnly;
    },

    //returns true if device is wider than 1264px
    isPcBool() {
      return this.$vuetify.breakpoint.lgAndUp;
    },

    //returns true if device is thinner than 1264px
    isPadBool() {
      return this.$vuetify.breakpoint.mdAndDown;
    },

    //returns true if device is thinner than 600px (vertical phone screens)
    isPhoneBool() {
      return this.$vuetify.breakpoint.xsOnly;
    },

    //user info from login
    userInfo() {
      return this.$store.getters["userInfo"];
    },
    userAllowedImportExport() {
      return this.userInfo?.AllowImportExport === true;
    },

    FieldMapping() {
      return this.$store.getters['FieldMapping'];
    },

    ClientHeight() {
      return this.$store.state.clientheight;
    },

    isSuperAdmin() {
      return (this.userInfo && this.userInfo.UserLogonName && this.userInfo.UserLogonName === 'serviceprovider') ? true : false;
    },
  },
});

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

import ElementLocale from 'element-ui/lib/locale'
import DatePicker from 'element-ui/lib/date-picker'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(DatePicker);
ElementLocale.i18n((key, value) => i18n.t(key, value))

import QAutoComplete from "@/components/Inputs/QAutoComplete.vue"
import QButtonGroup from "@/components/Inputs/QButtonGroup.vue"
import QCheckboxInput from "@/components/Inputs/QCheckboxInput"
import QDateTimeField from "@/components/Inputs/QDateTimeField.vue"
import QSwitchInput from "@/components/Inputs/QSwitchInput.vue"
import QTextArea from "@/components/Inputs/QTextArea.vue"
import QTextField from "@/components/Inputs/QTextField.vue"
import QInfo from "@/components/QInfo.vue"

Vue.component('QTextField', QTextField)
Vue.component('QTextArea', QTextArea)
Vue.component('QSwitchInput', QSwitchInput)
Vue.component('QCheckboxInput', QCheckboxInput)
Vue.component('QAutoComplete', QAutoComplete)
Vue.component('QButtonGroup', QButtonGroup)
Vue.component('QDateTimeField', QDateTimeField)
Vue.component('QInfo', QInfo)
